function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDoubleLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.3 6l1.41 1.41L8.13 12l4.58 4.59L11.3 18l-6-6 6-6z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3 6l1.41 1.41L14.13 12l4.58 4.59L17.3 18l-6-6 6-6z",
    fill: props.fill
  }));
}
export default SvgChevronDoubleLeft;